import { render, staticRenderFns } from "./module.layout.vue?vue&type=template&id=2499d58a&scoped=true"
import script from "./module.layout.ts?vue&type=script&lang=ts&external"
export * from "./module.layout.ts?vue&type=script&lang=ts&external"
import style0 from "./module.layout.vue?vue&type=style&index=0&id=2499d58a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499d58a",
  null
  
)

export default component.exports